module.exports = __webpack_public_path__ + "static/work26-272f8df3028e8411a980187b21a8f3ea.jpg";